export default "__VITE_PUBLIC_ASSET__52587633__"